'use client';

import {type ReactNode} from 'react';
import {useSearchParams} from 'next/navigation';
import {Loading} from '@delorand/ui/src/loader';
import {client} from 'c/utils/api';
import queryString from 'query-string';
import useSWR from 'swr';
import {fetchApi} from '../../utils/misc';
import {Item} from './_item';

interface Props {
  children?: ReactNode;
  limit: number;
  type?: 'big' | 'normal';
}

const ItemsGrid = ({children, limit = 12}: Props) => {
  const searchParams = useSearchParams();
  const parsedQS = queryString.parse(searchParams.toString(), {
    arrayFormat: 'comma',
  }) as {[name: string]: any};

  // const otherFields = Object.keys(parsedQS).;

  const {data, isLoading, isValidating} = useSWR(
    [searchParams.toString()],
    async () =>
      (
        await fetchApi(
          client.product.$post({
            json: {
              limit,
              pricerange: parsedQS?.price as string[] | undefined,
              sort: parsedQS?.sort,
            },
          })
        )
      ).data,
    {revalidateOnFocus: false}
  );

  // if (!data) return <Loading />;

  return (
    <>
      <div className="mx-aut relative flex h-full w-full flex-col px-2 pb-4 md:w-fit md:rounded-t-2xl">
        {children}
        <div
          className={`mx-auto my-2 grid w-full max-w-7xl grid-cols-1 gap-4 p-3 md:grid-cols-1`}
        >
          {data?.items.map(item => (
            <div
              key={item.id}
              className="border-b border-b-[#303030] pb-4 last:border-none"
            >
              <Item flex={false} product={item as any} />
            </div>
          ))}
        </div>
        {(isLoading || isValidating) && <Loading />}
      </div>
    </>
  );
};

export default ItemsGrid;
